<template>
  <picker-field :label="label" :display="display" :value="value" ref="picker" @open="onSearch">
    <div class="list">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in extraItems"
          :key="item.display"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.display}}</p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
        <div
          class="weui-cell weui-cell_access"
          v-for="item in filteredItems"
          :key="item.id"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.cr_name}}</p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
      </div>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField
  },
  props: {
    label: {
      type: String,
      default: "币种"
    },
    value: String,
    // 是否默认值取系统本位币
    useDefault: {
      type: Boolean,
      default: false
    },
    // 是否排除系统本位币（只考虑外币）
    noDefault: {
      type: Boolean,
      default: false
    },
    // 扩展其他项
    extraItems: Array
  },
  data() {
    return {
      display: null,
      items: []
    };
  },
  computed: {
    filteredItems() {
      var me = this,
        items = me.items;
      if (items && me.noDefault) {
        return items.filter(item => !item.cr_standard);
      }
      return items;
    }
  },
  created() {
    var me = this;
    // 使用系统本位币作为默认值
    if (me.useDefault && !me.value) {
      me.loadDefault();
    }
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.cr_name);
      me.$emit("select", item);
      me.display = item.display || item.cr_name;
      me.$refs.picker.close();
    },
    onSearch() {
      var me = this;
      me.$loading({
        url: "/api/document/currency/list",
        params: {
          number: 1,
          size: 100
        }
      }).then(function(res) {
        if (res.success) {
          me.items = res.data ? res.data.list : [];
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    },
    loadDefault() {
      var me = this;
      me.$loading({
        url: "/api/document/currency/getStandard"
      }).then(function(res) {
        if (res.success) {
          me.select(res.data);
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    }
  }
};
</script>